/**
 * ShareWarningBanner
 * 
 * Reusable warning banner for Firefox share functionality issues
 * Minimal, focused component using existing notification patterns
 */
import React, { useEffect, useState } from 'react';

const DISMISS_KEY = 'pista-firefox-share-warning-dismissed';

/**
 * @param {Object} props
 * @param {string} props.message - Custom warning message
 * @param {string} props.className - Additional CSS classes
 */
function ShareWarningBanner({ 
  message = "Share functionality may be limited in Firefox. Contents copied to clipboard, ready to share.",
  className = ""
}) {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY) === '1') {
        setDismissed(true);
      }
    } catch {
      // ignore localStorage errors
    }
  }, []);

  if (dismissed) {
    return null;
  }

  const handleDismiss = (e) => {
    e.stopPropagation();
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // ignore localStorage errors
    }
    setDismissed(true);
  };

  return (
    <div className={`share-warning-banner ${className}`}>
      <span className="warning-icon">⚠️</span>
      <span className="warning-message">{message}</span>
      <button
        type="button"
        className="share-warning-close"
        onClick={handleDismiss}
        aria-label="Dismiss warning"
      >
        ×
      </button>
    </div>
  );
}

export default ShareWarningBanner;
